<template>
  <div>
    <div style="padding-top:10px;margin-left:20px;margin-right:20px;">
     
      <v-carousel>
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
        ></v-carousel-item>
      </v-carousel>
    </div>
    <div style="margin-left:20px;margin-right:20px;">
      <v-row>
        <v-col md="4">
          <img src="../../assets/of1.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/ofr.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/rel.jpg" style="width:100%; height:auto;" />
        </v-col>
      </v-row>
    </div>
    <div style="margin-left:20px;margin-right:20px;">
      <v-card style="padding:16px;">
        <!-- <v-card style="margin-top:10px;" height="100%" class="mx-auto"> -->
        <v-row class="mb-6">
          <v-col md="4">
            <v-icon style="color:blue;padding-left:10px;font-size:50px;">mdi-car</v-icon>

            <v-card-title style="'padding-left:20px;">Fast Delivery</v-card-title>

            <p
              style="text-align:justify;padding-left:20px;"
            >Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
          </v-col>
          <br />
          <v-col md="4">
            <v-icon style="color:blue;padding-left:10px;font-size:50px;">mdi-domain</v-icon>

            <v-card-title>Creative Strategy</v-card-title>

            <p
              style="text-align:justify;padding-left:20px;"
            >Lorem ipsum, dolor sit amet consectetur adipisicing elit. Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
          </v-col>
          <br />
          <v-col md="4">
            <v-icon style="color:blue;padding-left:10px;font-size:50px;">mdi-lock</v-icon>

            <v-card-title>High Secured</v-card-title>

            <p
              style="text-align:justify;padding-left:20px;"
            >Lorem ipsum, dolor sit amet consectetur adipisicing elit.Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
          </v-col>
          <br />
        </v-row>
        <!-- </v-card> -->
      </v-card>
    </div>

    <div>
      <v-card style="margin-top:10px;margin-left:20px; margin-right:20px;">
        <v-card-title class="down pop">
          <b>Popular Products</b>
          <v-spacer></v-spacer>
          <div class="my-2">
            <v-btn color="#ff4e00" dark block>View All</v-btn>
          </div>
        </v-card-title>
        <!-- <hr /> -->
        <!-- <br> -->
        <v-flex>
          <v-row style="margin-left:20px;margin-right:20px;">
           <v-col md="3" v-for="i in data.slice(0,4)">
         
            <div style="padding-top:0px;">
           
              <v-img :src="'https://api.inguzsales.in/u/' +i.photos[0]" height="156" width="auto" />
            </div>
            <!-- <v-img :src="'https://picsum.photos/300/300?random=1'+i.photo1" /> -->
            <v-card-title primary-title></v-card-title>
            <v-card-text>
              <div>
                <span style="font-size:20px;font-weight:500;color:black;">
                  <strong>{{i.productname}}</strong>
                </span>
                 <v-flex md12>
                <v-row>
                  <v-col>
                <star-rating style=""
                  v-bind:increment="1"
                  v-bind:star-size="14"
                  active-color="#ff4e00"
                  :read-only="true"
                  v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                  required
                ></star-rating>
                 </v-col>
                  <v-col>
                    <div v-if="i.instock">(In Stock)</div>
                    <div v-else>(Out of Stock)</div>
                  </v-col>
                </v-row>
                </v-flex>
              </div>
              <v-flex md12>
                <v-row>
                  <v-col>
                    <span style="font-size:20px;color:black;">
                      <strong>₹{{i.price.toFixed(1)}}</strong>
                    </span>
                  </v-col>
                
                </v-row>
              </v-flex>
              <div >
              <span style="font-size:15px;font-weight:300;color:black;">
                <span style="text-align:justify;" class="prfont"><p>{{i.description.slice(0,30)}}..</p></span>
                <!-- <br /> -->
              </span>
              </div>
           
                
             
              <!-- <br /> -->

              <v-flex md12>
                 <!-- <router-link to="/AppLogin">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link> -->
        <router-link :to="'/Product/' +i.productname">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link>
                <v-row>
                  <v-col align="center">
                    
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          
        </v-col>
          </v-row>
        </v-flex>
      </v-card>
    </div>

   
    <div>
      <v-card style="margin-top:10px;margin-left:20px; margin-right:20px;">
        <v-card-title class="down pop">
          <b>New Arrived</b>
          <v-spacer></v-spacer>
          <div class="my-2">
            <v-btn color="#ff4e00" dark block>View All</v-btn>
          </div>
        </v-card-title>
       
        <v-flex>
          <v-row style="margin-left:20px;margin-right:20px;">
             <v-col md="3" v-for="i in data.slice(0,4)">
         
            <div style="padding-top:0px;">
           
              <v-img :src="'https://api.inguzsales.in/u/' +i.photos[0]" height="156" width="auto" />
            </div>
            <!-- <v-img :src="'https://picsum.photos/300/300?random=1'+i.photo1" /> -->
            <v-card-title primary-title></v-card-title>
            <v-card-text>
              <div>
                <span style="font-size:20px;font-weight:500;color:black;">
                  <strong>{{i.productname}}</strong>
                   
                </span>
                 <v-flex md12>
                <v-row>
                  <v-col>
                <star-rating style=""
                  v-bind:increment="1"
                  v-bind:star-size="14"
                  active-color="#ff4e00"
                  :read-only="true"
                  v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                  required
                ></star-rating>
                 </v-col>
                  <v-col>
                    <div v-if="i.instock">(In Stock)</div>
                    <div v-else>(Out of Stock)</div>
                  </v-col>
                </v-row>
                </v-flex>
              </div>
              <v-flex md12>
                <v-row>
                  <v-col>
                    <span style="font-size:20px;color:black;">
                      <strong>₹{{i.price.toFixed(1)}}</strong>
                    </span>
                  </v-col>
                
                </v-row>
              </v-flex>
              <div >
              <span style="font-size:15px;font-weight:300;color:black;">
                <span style="text-align:justify;" class="prfont"><p>{{i.description.slice(0,30)}}..</p></span>
                <!-- <br /> -->
              </span>
              </div>
           
                
             
              <!-- <br /> -->

              <v-flex md12>
                 <!-- <router-link to="/AppLogin">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link> -->
        <router-link :to="'/Product/' +i.productname">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link>
                <v-row>
                  <v-col align="center">
                    
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          
        </v-col>
          </v-row>
        </v-flex>
      </v-card>
    </div>

   
    <div style="margin-left:40px;margin-right:40px;">
      <v-row>
        <v-col md="4">
          <img src="../../assets/ph.png" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/me.jpg" style="width:100%; height:auto;" />
        </v-col>
        <v-col md="4">
          <img src="../../assets/rel.jpg" style="width:100%; height:auto;" />
        </v-col>
      </v-row>
    </div>

    <br />
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
// import AppSideNav from "@/components/common/AppSideNav";

export default {
  props: ["id"],
  components: {
    // AppSideNav,
    StarRating
  },
  data() {
    return {
      items: [
        {
          src:
            "https://cdn.static-zoutons.com/images/originals/stores/Nykaa_App_1568270141.jpg"
        },
        {
          src:
            "https://cdn.static-zoutons.com/images/originals/stores/Flipkart_App_1569412752.jpg"
        },
        {
          src:
            "https://www.nokiacamp.com/wp-content/uploads/2018/10/Nokia-offer.jpg"
        },
        {
          src:
            "https://opt.toiimg.com/recuperator/img/toi/m-73692781/73692781.jpg?resizemode=1&width=215&height=145"
        }
      ],
      data: [],
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
  beforeMount() {
    this.getproducts();
  },
  methods: {
  
         getproducts() {
      axios({
        method: "GET",
        url: "/product/all/"
      }).then(Response => {
        this.data = Response.data.data;
       
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.data.length; i++) {
           
            var tyid = this.data[i]._id;
            // temp.push(ty);
            tempid.push(tyid);
          }
          
          this.did = tempid;
          this.visible = false;
        
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
  
  }
};
</script>

<style>
.prfont {
  font-family: "Montserrat";
}
@media (min-width: 360px) and (max-width: 760px) {
  .apple {
    width: 45%;
    height: auto;
  }
}
@media (min-width: 761px) and (max-width: 2000px) {
  .apple {
    width: 80%;
    height: auto;
  }
}
@media (min-width: 1264px) {
  .ms {
    max-width: 1300px !important;
  }
}
.v-toolbar__title {
  font-size: 0rem !important;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media only screen and (min-width: 960px) and (max-width: 1060px) {
  .AppHeading {
    font-size: 12px !important;
  }
}
.nav_item {
  margin-top: 5px;
  margin-right: 20px;
}
.AppHeading {
  color: black;
  font-family: proxima;
  font-size: 16px;
  font-weight: 800 !important;
  letter-spacing: 1px !important;
}
.AppMenu {
  color: white;
  font-family: opensans;
  font-size: 12px !important;
  font-weight: 100 !important;
  text-transform: uppercase;
}
@media only screen and (min-width: 360px) and (max-width: 760px) {
  .prod {
    margin-left: 50px;
    margin-right: 50px;
  }
}
@media only screen and (min-width: 761px) and (max-width: 2000px) {
  .prod {
    margin-left: 120px;
    margin-right: 120px;
  }
}
.down {
  padding-left: 40px;
}
.vue-star-rating-rating-text {
  display: none !important;
}
</style>

